import { PartiStoreService } from '../../Progetti/_services/parti-store.service';
import { ApiRestService } from '../../Progetti/_services/api-rest.service';
import { ProdottiStoreService } from '../../Progetti/_services/prodotti-store.service';
import { Categorie } from '../../Progetti/Models/Categorie';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-categorie',
  templateUrl: './categorie-parti.component.html',
  styleUrls: ['./categorie-parti.component.scss']
})
export class CategoriePartiComponent implements OnInit{
  categoriedropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    textField: 'categoria',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  sel_cat_id: number = 0;
  type;
  hasCategorie = environment.PartiAddOn[0];
  CategoriaDaModificare: Categorie = null;
  LabelCategoria: string = "";
  showMenu = '';
  showSubMenu = '';
  modificheAbilitate: boolean = false;
  CategorieLineare: Categorie[] = [];
  CategorieSelezionate: Categorie[] = [];
  public sidebarnavItems: Categorie[] = []
  path = '';
  createButtonClick = true;
  @Input() showClass: boolean = false;
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();


  handleNotify() {
    this.notify.emit(!this.showClass);
  }

  constructor(private progettiStore: PartiStoreService, private modalService: NgbModal, private apirest: ApiRestService, public router: Router, private route: ActivatedRoute,) {
    this.progettiStore.getCategorieProdotti();
    this.progettiStore.$categorieProdotti.subscribe(data => this.sidebarnavItems = data);
    this.progettiStore.$categorieProdottiLineare.subscribe(data => {
      if (data !== null)
        this.CategorieLineare = data;
    });
  }
  ngOnInit() {
    this.route.params.subscribe(data => {
      this.type = data['type'];
      console.log(this.type)
      if (!isNaN(parseInt(this.type)))
        this.sel_cat_id = parseInt(this.type);
    })
  }

  AbilitaModifiche(){
    this.modificheAbilitate =  !this.modificheAbilitate;
  }
  Elimina(value: Categorie){
    if(confirm("Sei sicuro di voler eliminare questa categoria?")){
      this.apirest.deleteCategoria(value).subscribe(data => {
      this.progettiStore.getCategorieProdotti();
      })
    }
  }

  filtroCategoria(item: string) {
    if (item.length >= 3) {
      this.progettiStore.getCategorieListanofigli(new RicercaPaginazione(item, undefined, undefined));
    }
  }
  clicked(cat:Categorie){
    if(cat&&!isNaN(cat.id)){this.sel_cat_id = cat.id;
    console.log(this.sel_cat_id)
      this.router.navigate([this.route.snapshot.queryParams[`progetti/parti/lista/${cat.id.toString()}`] || `progetti/parti/lista/${cat.id.toString()}`,]);}
  }

  openModal(targetModal: NgbModal, selected: Categorie, selectedParent: Categorie) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
    this.CategoriaDaModificare = selected;
    this.CategorieSelezionate = [];
    if (selected !== null && selectedParent !== null) {
      this.LabelCategoria = selected.categoria;
      this.CategorieSelezionate.push(selectedParent);
    } else if (selected !== null) {
      this.LabelCategoria = selected.categoria;
      this.CategorieSelezionate = [];
    } else {
      this.LabelCategoria = "";
      this.CategorieSelezionate = [];
    }
  }

  saveModalButton() {
    if (this.CategoriaDaModificare !== null) {
      const updateData = new Categorie();
      updateData.id = this.CategoriaDaModificare.id;
      updateData.categoria = this.LabelCategoria;
      if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
        updateData.cat_id = this.CategorieSelezionate[0].id;
      else
        updateData.cat_id = undefined;
      this.apirest.updateCategoria(updateData).subscribe(data => {
        this.progettiStore.getCategorieProdotti();
        this.closeBtnClick()
      });
    } else {
      const updateData = new Categorie();
      updateData.categoria = this.LabelCategoria;
      if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
        updateData.cat_id = this.CategorieSelezionate[0].id;
      else
        updateData.cat_id = undefined;
      this.apirest.addCategoria(updateData).subscribe(data => {
        this.progettiStore.getCategorieProdotti();
        this.closeBtnClick()
      });
    }
  }
  deleteModalButton() {
    const updateData = new Categorie();
    updateData.id = this.CategoriaDaModificare.id;
    if (this.CategorieSelezionate != null && this.CategorieSelezionate.length > 0)
      updateData.cat_id = this.CategorieSelezionate[0].id;
    else
      updateData.cat_id = undefined;
    this.apirest.deleteCategoria(updateData).subscribe(data => {
      this.progettiStore.getCategorieProdotti();
      this.closeBtnClick()
    });
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    //this.ngOnInit();
  }

}
